import { Flex, Group, Pill, Stack, Text } from '@mantine/core';

import { EditorialTeamValidationAction } from '@/module/Author/EditorialTeam/Validation/EditorialTeamValidationAction';
import { EditorialTeamValidationHistory } from '@/module/Author/EditorialTeam/Validation/EditorialTeamValidationHistory';
import { EditorialTeamDeleteButton } from '@/module/Author/EditorialTeam/components/EditorialTeamDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { EditorialTeamProofAction } from './Proof';
import { EditorialTeam } from './model/EditorialTeamTypes';

interface EditorialTeamViewProps {
  editorialTeam: EditorialTeam;
}

export function EditorialTeamView(props: EditorialTeamViewProps) {
  const { editorialTeam } = props;
  const {
    type,
    startYear,
    endYear,
    journalName,
    publisherName,
    journalReputation,
    publisherReputation,
    reachType,
    authors,
  } = editorialTeam;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Text fw="500">{type === 'JOURNAL' ? journalName : publisherName}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <EditorialTeamDeleteButton editorialTeamId={editorialTeam.id} />
            </Group>
          </Flex>
          <Group>
            <Pill>{type}</Pill>
            <Pill>{type === 'JOURNAL' ? journalReputation : publisherReputation}</Pill>
            <Pill>{reachType}</Pill>
            <Text
              c="dimmed"
              size="xs"
            >
              {startYear} - {endYear}
            </Text>
          </Group>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <EditorialTeamProofAction
        editorialTeamId={editorialTeam.id}
        authors={authors}
      />
      <EditorialTeamValidationAction editorialTeamId={editorialTeam.id} />
      <EditorialTeamValidationHistory editorialTeamId={editorialTeam.id} />
    </Stack>
  );
}
